export default function UserDetail() {
  return <>UserDetail</>;
}
